import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var Container = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (React.createElement("div", { id: id, className: cn(styles.container, className), style: style }, children));
};
export default Container;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/container/index.tsx
// module id = Bs0H
// module chunks = 2